import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockShift = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 12 12",
	width: "1em",
	height: "1em",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M6 1a5 5 0 1 1 0 10a5 5 0 0 1 0-10zM6 2a4 4 0 1 0 0 8a4 4 0 0 0 0-8z"
	}), /* @__PURE__ */ _jsx("path", { d: "M6 6V3A3 3 0 0 1 9 6z" })]
});
const ForwardRef = forwardRef(SvgClockShift);
export default ForwardRef;
